import { observer } from "mobx-react-lite";
import { Button } from "@/components/ui/button";
import { useTran } from "@/hooks";
import { customDisclosureStore } from "../../stores/custom-disclosure.store";
import DisclosureTableRow from "./DisclosureTableRow";

const DisclosureTable = observer(({ onCreate, onEdit }) => {
  const { t } = useTran();
  const {
    filteredDisclosures,
    loading,
    selectedIds,
    selectAll,
    clearSelection,
    toggleSelection,
  } = customDisclosureStore;

  const allSelected =
    selectedIds.length === filteredDisclosures.length &&
    filteredDisclosures.length > 0;

  return (
    <div className="flex-1 rounded-radius border border-border bg-card overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="border-b border-border bg-muted/50">
            <tr>
              <th className="w-12 p-3">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(e) => {
                    if (e.target.checked) {
                      selectAll();
                    } else {
                      clearSelection();
                    }
                  }}
                  className="h-4 w-4"
                />
              </th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">
                {t("Code")}
              </th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">
                {t("Title")}
              </th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">
                {t("Category")}
              </th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">
                {t("Type")}
              </th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">
                {t("Usage")}
              </th>
              <th className="p-3 text-left text-sm font-medium text-muted-foreground">
                {t("Status")}
              </th>
              <th className="p-3 text-right text-sm font-medium text-muted-foreground">
                {t("Actions")}
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={8} className="p-8 text-center">
                  <p className="text-sm text-muted-foreground">
                    {t("Loading...")}
                  </p>
                </td>
              </tr>
            ) : filteredDisclosures.length === 0 ? (
              <tr>
                <td colSpan={8} className="p-8 text-center">
                  <p className="text-sm text-muted-foreground">
                    {t("No custom disclosures found")}
                  </p>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={onCreate}
                    className="mt-2"
                  >
                    {t("Create your first custom disclosure")}
                  </Button>
                </td>
              </tr>
            ) : (
              filteredDisclosures.map((disclosure) => (
                <DisclosureTableRow
                  key={disclosure._id}
                  disclosure={disclosure}
                  onEdit={onEdit}
                />
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
});

export default DisclosureTable;
